module.exports = __webpack_public_path__ + "assets/img/StrengthenA.dc8f87c0.jpg";